var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',[_c('Page_Devices',{attrs:{"testfield":_vm.testfield}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }